<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path opacity="0.2" d="M16 6H4V8H13V16H16V6Z" fill="currentColor" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6 2.00024C7.10449 2.00024 7.99987 2.89554 8 4L16 4C17.1046 4 18 4.89543 18 6V16C18 17.1046 17.1046 18 16 18L4 18C2.89551 18 2.00013 17.1047 2 16.0002V4.00024C2 2.89567 2.89543 2.00024 4 2.00024L6 2.00024ZM16 6L4 6L4 8L13 8C14.1046 8 15 8.89543 15 10L15 16H16V6ZM4 16L4 10L13 10L13 16H4Z"
    fill="currentColor"
  />
</svg>
